import { Match } from "model/Match/Match";
import { getNumTeams } from "model/Match/MatchTeams";
import { getRosterIdOrPlaceholder } from "model/Roster/Roster";
import { MatchTeam } from "./MatchTeam";
import { MatchTeamsContainer } from "./styles";

interface Props {
  match: Match;
  tournamentId: string;
  showScore: boolean;
}

export const MatchTeams = ({ match, tournamentId, showScore }: Props) => {
  const numTeams = getNumTeams(match.teams);
  if (numTeams > 10) {
    return <span>{numTeams} Teams</span>;
  }

  return (
    <MatchTeamsContainer>
      {match.teams.rosters.map((roster, i) => {
        const rosterId = getRosterIdOrPlaceholder(roster);
        return (
          <MatchTeam
            key={`${i}-${rosterId}`}
            match={match}
            rosterId={rosterId}
            tournamentId={tournamentId}
            showScore={showScore}
          />
        );
      })}
    </MatchTeamsContainer>
  );
};
